<template>
    <Loading v-bind:show="showLoadingCancelados">
        <PageTitle title="Serviços - Cancelados" />
        <Grid v-if="servicosCancelados && $featureToggle && $featureToggle.INTEGRA_SERVICOS_CANCELADOS"
              v-bind:Data="servicosCancelados.servico"
              v-bind:Header="headerCancelados"
              Name="ServicosCancelados"
              Title="Cancelados"
              OrderBy="datavencimento"
              v-bind:HeaderDetalhes="null"
              v-bind:DetalhesCombo1="servicosCancelados.periodo"
              v-bind:DetalhesCombo2="servicosCancelados.situacao"
              v-bind:DetalhesCombo3="null" />
    </Loading>
</template>
<script>
    import Grid from '@/components/Grid';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import Servico from '@/services/ServicoService.js';

    export default {
        name: 'Servico',
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                this.servicoService = new Servico(this);

                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.ServicoCancelado) {
                        this.dadosAba = a.Servicos;
                    } else {
                        this.showLoadingCancelados = true;
                        this.dadosAba = this.cancelados();
                    }
                }
                else
                    this.$router.push('home');
            }

        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.ServicoCancelado = this.dadosAba;
            sessionStorage.setItem("Servicos", JSON.stringify(aluno));
        },
        data() {
            return {
                servicosCancelados: null,
                aluno: null,
                activeTab: "ativos",
                showLoadingCancelados: false,
                headerCancelados: [

                    {
                        Titulo: "Descrição",
                        Field: "descricaoCompleta",
                        Width: "200px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Valor (R$)",
                        Field: "valor_titulo",
                        Width: "120px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Data / Hora exclusão",
                        Field: "data_exclusao",
                        Width: "100px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Usuário",
                        Field: "usuario",
                        Width: "200px",
                        Tipo: "texto"
                    }
                ],
                dadosAba: null
            }
        },
        methods: {

            cancelados() {
                if (this.$featureToggle.INTEGRA_SERVICOS_CANCELADOS) {
                    this.showLoadingCancelados = true;
                    this.servicoService.ListarServicosCancelados({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        Pagina: 1,
                        ItensPagina: 100,
                        Ano: null,
                        Mes: null
                    }).then(
                        data => {
                            if (data.ok) {
                                this.servicosCancelados = data.dados;
                            }
                            else {
                                this.$modal.alert(data.mensagem);
                            }
                        },
                        error => {
                            this.$modal.error('Ocorreu um erro ao tentar buscar os dados.', (error.body?.Mensagem || error?.response?.statusText || error.message));
                        }).finally(() => {
                            this.showLoadingCancelados = false;
                        });
                }
                else {
                    this.$modal.alert(this.$msgFeatureToggle);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
